<template>
    <a-menu v-model:selectedKeys="selectedKeys" theme="light" mode="inline" :open-keys="openKeys" @openChange="onOpenChange">
        <template v-for="route in MainRoute">
            <a-sub-menu v-if="route.children && route.name != 'hidden' && route.meta.title != undefined"
             :key="route.name" :title="route.meta.title" @titleClick="subMenuClick(route)">
                <template #icon>
                    <Icon v-if="route.meta.icon" :icon="route.meta.icon" />
                </template>
                <template v-for="sub in route.children">
                    <a-menu-item v-if="sub.meta.title != undefined" :key="sub.name">
                        <template #icon>
                            <Icon v-if="sub.meta.icon" :icon="sub.meta.icon" />
                        </template>
                        <router-link :to="{name: sub.name}">{{sub.meta.title}}</router-link>
                    </a-menu-item>
                </template>
            </a-sub-menu>
            <a-menu-item v-else-if="route.name != 'hidden' && route.meta.title != undefined" :key="route.name">
                <template #icon>
                    <Icon v-if="route.meta.icon" :icon="route.meta.icon" />
                </template>
                <router-link :to="{name: route.name}">{{route.meta.title}}</router-link>
            </a-menu-item>
        </template>
    </a-menu>
</template>
<script>
import { MainRoute } from "../router";
import { reactive, toRefs,watch } from "vue";
import { createVNode } from "vue";
import * as $Icon from "@ant-design/icons-vue";
import { useRoute,useRouter } from 'vue-router';

export default {
    components: {
        Icon: (props) => createVNode($Icon[props.icon]),
    },
    setup() {
        const state = reactive({
            rootSubmenuKeys: MainRoute.map((item) => item.name),
            openKeys: [],
            selectedKeys: [],
        });
        const router = useRouter();
        let route = useRoute();
        state.selectedKeys.push(route.name);
        state.openKeys.push(route.meta.parent);

        const onOpenChange = (openKeys) => {
            const latestOpenKey = openKeys.find((key) => state.openKeys.indexOf(key) === -1);
            if (state.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
                state.openKeys = openKeys;
            } else {
                state.openKeys = latestOpenKey ? [latestOpenKey] : [];
            }
        };
        
        // 点击不同子菜单跳转子菜单第一个选项，点击相同的子菜单收起
        const subMenuClick = (route) => {
            // 当前子菜单名称
            let parent = router.currentRoute.value.meta.parent;
            if(route.name != parent){
                router.push({name:route.children[0].name});
            }
        };

        // 监听路由变化改变menu选中状态
        watch(() => route.name, () => {
            if( route.matched.length < 3 ){
                state.openKeys.length = 0;
                state.selectedKeys.length = 0;
                state.selectedKeys.push(route.name);
                state.openKeys.push(route.meta.parent);
            }
          
        });
        return {
            MainRoute,
            ...toRefs(state),
            onOpenChange,
            router,
            subMenuClick,
        };
    },
};
</script>

